import React from "react"
import _ from "lodash"
import {Row, Col} from "reactstrap"
//************************************//
import {trans} from '@utils'
//************************************//
import FieldsList from "@csrc/components/fields/FieldsList"
import EntityDetails from "@csrc/components/fields/EntityDetails"
import CustomFieldsProvider from "@csrc/components/fields/CustomFieldsProvider"
import {_deleteAssignmentSettingUnusedCustomField, _updateAssignmentSettingCustomFields} from "@csrc/modules/assignment/redux/actions"
//************************************//
const ManageCustomFieldsIndex = (props) => {
  //************************************//
  const {uuid, customFieldsState} = props
  //************************************//
  const {customFields, setCustomFields} = customFieldsState
  //************************************//
  const onSubmit = (data, callback) => {
    _updateAssignmentSettingCustomFields(
      data,
      callback
    )
  }
  //************************************//
  const onDeleteUnusedCustomFields = async (id, callback) => {
    return await _deleteAssignmentSettingUnusedCustomField(
      id,
      callback
    )
  }
  //************************************//
  return (
    <CustomFieldsProvider
      initUnusedFields={customFields.unusedCustomFieldsList}
      initEntityFields={customFields.entityCustomFieldsList}
      initEntityData={customFields.entityData}
      customFieldsState={customFieldsState}
    >
      <Row>
        <Col sm={4}>
          <FieldsList
            customFieldsState={customFieldsState}
            actionDeleteUnusedCustomFields={'APP_EDIT_SETTINGS'}
            onDeleteUnusedCustomFields={onDeleteUnusedCustomFields}
          />
        </Col>
        <Col sm={8}>
          <EntityDetails
            entityName={trans('settings.nav.assignmentSettings')}
            submitAction={'APP_EDIT_SETTINGS'}
            onSubmit={onSubmit}
            customFieldsState={customFieldsState}
            staticFields={[{name: trans('assignment.title'), field_type: 'text', required: true}]}
          >
          </EntityDetails>
        </Col>
      </Row>
    </CustomFieldsProvider>
  )
}
//************************************//
export default ManageCustomFieldsIndex
